import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Alert
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { createEvent } from '../services/api';

const CreateEventPage: React.FC = () => {
  const navigate = useNavigate();
  
  const [eventId, setEventId] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!eventId) {
      setError('Please enter an event ID');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      await createEvent({
        external_event_id: eventId,
      });
      
      navigate('/');
    } catch (err) {
      console.error('Error creating event:', err);
      setError('Failed to create event. Please try again later.');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <Box>
      <Button 
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/')}
        sx={{ mb: 3 }}
      >
        Back to Events
      </Button>
      
      <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
        Create New Event
      </Typography>
      
      <Card>
        <CardContent>
          {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
          
          <Box component="form" onSubmit={handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  required
                  label="External Event ID"
                  value={eventId}
                  onChange={(e) => setEventId(e.target.value)}
                  helperText="Enter the event ID from Beat81"
                />
              </Grid>
              
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={loading}
                  >
                    {loading ? 'Creating...' : 'Create Event'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default CreateEventPage; 